// extracted by mini-css-extract-plugin
export default {"PlayerRange":"style_PlayerRange__izK0x","Mini":"style_Mini__WIwWS"};